interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ eyebrow, title, desc }: SectionHeadingProps) {
  return (
    <div className="max-w-2xl">
      <div className="mb-3 flex items-center gap-2">
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-bookmark-3-line text-xs"></i>
        </span>
        <span className="font-label text-xs font-medium uppercase tracking-[0.18em] text-primary-600">
          {eyebrow}
        </span>
      </div>
      <h3 className="font-heading text-2xl font-bold leading-tight tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h3>
      {desc ? (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
      ) : null}
    </div>
  );
}